import logging from '@common/logging';
import React from 'react';

export const useAsyncError = () => {
  const [, setError] = React.useState();
  return React.useCallback(
    (e: Error) => {
      setError(() => {
        logging.logError(e);
        throw e;
      });
    },
    [setError],
  );
};
